module.exports = __webpack_public_path__ + "img/pic01.f2b6c9c8.png";